import script from "./renewal-required.vue?vue&type=script&setup=true&lang=js"
export * from "./renewal-required.vue?vue&type=script&setup=true&lang=js"

import "./renewal-required.vue?vue&type=style&index=0&id=4882e2a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4882e2a6"]])

export default __exports__